import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const LogoutIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.3721 0C12.8247 0 13.1914 0.366333 13.1914 0.818176L13.1914 7.20001L12.3721 7.20001L12.3721 0.818176L0.819336 0.818176L0.819336 17.1818L12.3721 17.1818L12.3721 10.8L13.1914 10.8L13.1914 17.1818C13.1914 17.6337 12.8247 18 12.3721 18L0.819336 18C0.366699 18 0 17.6337 0 17.1818L0 0.818176C0 0.366333 0.366699 0 0.819336 0L12.3721 0ZM15.2637 8.50006L14.4551 7.51782C14.3672 7.41119 14.3301 7.28918 14.3433 7.15179C14.3569 7.01434 14.4165 6.90173 14.5234 6.81403C14.6079 6.74451 14.7046 6.70673 14.814 6.70081C14.9233 6.69482 15.0234 6.72186 15.1152 6.7818L17.8633 8.58179C17.9785 8.65741 18.0508 8.76282 18.0786 8.89801C18.1069 9.0332 18.083 9.15851 18.0073 9.27399C17.9888 9.30273 17.9673 9.32928 17.9429 9.35358C17.9185 9.37793 17.8921 9.39948 17.8633 9.41833L15.1152 11.2183C14.9995 11.2939 14.874 11.3177 14.7393 11.2896C14.604 11.2614 14.4985 11.1895 14.4229 11.074C14.3628 10.9825 14.3359 10.8821 14.3418 10.7729C14.3477 10.6636 14.3857 10.5668 14.4551 10.4823L15.2637 9.50006L6.59668 9.50006C6.31641 9.50006 6.09668 9.28003 6.09668 9.00006C6.09668 8.72003 6.31641 8.50006 6.59668 8.50006L15.2637 8.50006Z"
        clipRule="evenodd"
        fill="currentColor"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
